export enum LocationType {
    Urban = 1,
    Suburban = 2,
    Rural = 3,
}

export const LocationTypes = [
    {
        id: LocationType.Urban,
        name: 'Urban',
    },
    {
        id: LocationType.Suburban,
        name: 'Suburban',
    },
    {
        id: LocationType.Rural,
        name: 'Rural',
    },
];

export const LocationTypeOptions = {
    [LocationType.Urban]: 'Urban',
    [LocationType.Suburban]: 'Suburban',
    [LocationType.Rural]: 'Rural',
};

export const locationTypeTooltipHtml =
    '<b style="font-weight:600">Urban</b> = Located within or directly adjacent to a major population center with high residential and commercial density, generally associated with cities exceeding 500k residents.' +
    '<br/><br/><b style="font-weight:600">Suburban</b> = Located outside a major city but within its surrounding commuter region, with moderate residential and commercial density and access to nearby urban centers.' +
    '<br/><br/><b style="font-weight:600">Rural</b> = Located more than 40 miles from a metro area with 5M+ residents, more than 30 miles from a metro area with 2M+ residents, more than 20 miles from a city with 500k+ residents, more than 10 miles from a city with 50k+ residents, and more than 5 miles from a town with 15k+ residents.';
